import type { CompleteStoreFragment } from '@drycut/graphql';

import { StoreWaitingTime } from '@drycut/controlled-components';
import { Para, Stack } from '@drycut/ui-components';
import { MAX_MINUTES_TO_DISPLAY } from '@drycut/ui-format-utils';
import { twJoin } from 'tailwind-merge';

import { StylistList } from './StylistList';

type Props = {
  manual?: boolean;
  store: CompleteStoreFragment;
};

export default function WaitingTimeDetails({ store, manual = false }: Props): React.ReactElement {
  const longerWait = store.waitingTime > MAX_MINUTES_TO_DISPLAY * 60;

  const waitingTimeClassName = twJoin('font-aribaubold text-primary-700', manual && 'text-3xl');

  return (
    <Stack gap={2}>
      {!longerWait && (
        <StylistList stylists={store.checkedInStylists} size={manual ? 'base' : 'sm'} />
      )}

      <Stack gap={1}>
        {!longerWait ? (
          <Para size={manual ? 'base' : 'sm'} pretty>
            Der nächste verfügbare Cut in
          </Para>
        ) : (
          <Para size={manual ? 'base' : 'sm'}>Nächster freier Termin in</Para>
        )}
        <Para as="span" className={waitingTimeClassName}>
          <StoreWaitingTime store={store} showCa showZero steps />
        </Para>
      </Stack>
    </Stack>
  );
}
